<template>
  <div class="main-container">
    <div v-if="showIntro">
      <div class="nav">
        <span>
          Payroll > Manage paygroups >
          <b>Add Paygroups</b>
        </span>
      </div>
      <tl-header type="h1">Pay Groups</tl-header>
      <div class="row-container center">
        <div class="company-info">
          <img class="image" src="@/assets/bands.svg">
          <div v-on:click="goBackToPayGroup">
            <img class="closeImage" src="@/assets/close.png">
          </div>
          <div class="fontStyle">
            <br>
            <span>Lorem ipsum dolor sit amet consectetur adipisicing elit. Ab neque necessitatibus accusamus sit animi perferendis, quasi voluptates optio, excepturi officiis magni nihil possimus nesciunt incidunt quidem.</span>
            <br>
            <span>preferrences from advance settings in the same section</span>
            <div class="divider"></div>
            <br>
            <br>
            <!-- {{ this.costCentreData }} -->
            <btn
              text="Get Started"
              type="secondary"
              class="rightAlign"
              v-on:click="goBackToPayGroup"
            ></btn>
            <!-- <div class="bottom-content">
            <span>You have not completed Location inputs for all entities. Please click here to complete.</span>
            </div>-->
          </div>
        </div>
      </div>

      <bottom-action-container class="placeAtEnd">
        <!-- <template slot="end">
        <btn-skip @navClicked="navHandler"></btn-skip>
        </template>-->
      </bottom-action-container>
    </div>
    <!-- <div v-else>
      <cost-center @displayIntro="goToIntro"/>
    </div>-->
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      showIntro: true
    };
  },
  activated() {
    this.fetchAllData();
  },
  methods: {
    ...mapActions("dashboard/payroll/monthlypayroll/payGroup/", {
      fetchAll:"fetchAll"
    }),
    goBackToPayGroup() {
      this.$router.push({
        path: `/dashboard/${this.$route.params.entity_index}/payroll/monthlypayroll/paygroupDetails`
      });
    },
    async fetchAllData(){
     try {
        await this.fetchAll();
        } catch (err) {
        //console.log(err);
      }
    }
  }
};
</script>





<style lang="scss" scoped>
.image {
  margin-top: 30px;
}
.nav {
  margin-bottom: 1.7%;
  color: #555555;
  font-size: 12px;
}
.main-container {
  width: 100%;
  padding: 20px 15px;
}
.row-container {
  .value {
    margin-right: 0;
  }
}

.bottom-content {
  margin-top: 170px;
}

.bottom-content span {
  margin-bottom: 0;
  border-bottom: 1px solid #105ca4;
  border-bottom-color: #105ca4;
  height: 18px;
  font-family: Montserrat;
  font-size: 14px;
  color: #105ca4;
}

.company-info {
  display: flex;
  padding: 20px;
  border-radius: 4px;
  box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.25);
  background-color: #ffffff;
  align-items: flex-start;
  position: relative;
  width: 100%;
}

.closeImage {
  position: absolute;
  float: right;
  top: 10px;
  right: 10px;
  cursor: pointer;
}

.building {
  width: 56px;
  height: 58px;
  object-fit: contain;
  margin: 25px 0 0 129px;
}

.fontStyle {
  margin-left: 20px;
  font-family: Montserrat;
  font-size: 16px;
  color: #404040;
}

.divider {
  color: #34c0be;
  border-bottom: 2px solid #34c0be;
  width: 100%;
  margin: 30px 0 0 5px;
}

.placeAtEnd {
  margin-top: 20px;
}
</style>
